import jsPDF from 'jspdf';

const addWatermark = (doc: jsPDF, imgSrc: string, width: number, height: number) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  const img = new Image();
  img.src = imgSrc;
  img.onload = function () {
    canvas.width = width;
    canvas.height = height;

    if (ctx) {
      ctx.globalAlpha = 0.1;
      ctx.drawImage(img, 0, 0, width, height);

      const imgData = canvas.toDataURL('image/png');

      const pageCount = doc.internal.pages.length;
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const xPosition = (pageWidth - width) / 2;
        const yPosition = (pageHeight - height) / 2;

        doc.addImage(imgData, 'PNG', xPosition, yPosition, width, height);

        const footerText = 'Powered by Coin Math';
        const footerYPosition = pageHeight - 10;

        doc.setFontSize(10);
        doc.text(footerText, pageWidth / 2, footerYPosition, { align: 'center' });
      }
    }
  };
};

export default addWatermark;
